import TextInput from "@/components/shared/forms/TextInput";
import {
  type Control,
  type FieldPath,
  type FieldValues,
  type UseControllerProps,
  useController,
} from "react-hook-form";

type ReadOnlySelectProps<
  TFieldValues extends FieldValues,
  TOption extends Record<string, string>,
> = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "name" | "value" | "readOnly"
> & {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  rules?: UseControllerProps<TFieldValues>["rules"];
  options: TOption[];
  optionValueKey?: keyof TOption;
  optionTextKey?: keyof TOption;
};

export default function ReadOnlySelect<
  TFieldValues extends FieldValues,
  TOption extends Record<string, string>,
>({
  control,
  name,
  rules,
  options,
  optionValueKey = "Value",
  optionTextKey = "Text",
  ...attributes
}: ReadOnlySelectProps<TFieldValues, TOption>) {
  const { field } = useController({ control, name, rules });
  const valueText = field.value == null ? "" : String(field.value);
  const match = options.find((x) => String(x[optionValueKey]) === valueText);

  return (
    <TextInput
      {...attributes}
      ref={field.ref}
      readOnly
      value={match ? match[optionTextKey] : valueText}
    />
  );
}
